import cx from 'clsx';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DeviceInfo } from '@ezugi/utils';

import { useIntl } from '../../hooks/useIntl';
import { menuActions, tipsActions } from '../../store/actions';
import { MenuSetPayload } from '../../store/reducers/menu';
import { widgetsSelector } from '../../store/selectors';
import { tipsButton, tipsButtonDesktop } from './GameResults.css';
import { useGameResults } from './useGameResults';

const ResultMessageTipsInner = () => {
  const tipsEnabled = (useSelector(widgetsSelector) as any)?.tips;

  const locales = useIntl({
    keys: {
      tipTheDealer: 'general.tip_the_dealer',
      tipLabel: 'games_ui.tip',
    },
  });

  const dispatch = useDispatch();

  const setMenu = useCallback(
    (payload: MenuSetPayload) => {
      dispatch(menuActions.menu.set(payload));
    },
    [ dispatch ]
  );

  const onTipsClick = useCallback(() => {
    setMenu({
      widget: { key: 'tips', label: locales.tipLabel, drawer: true },
      open: false,
    });
  }, [ setMenu, locales.tipLabel ]);

  const toggleTips = useCallback(() => {
    dispatch(tipsActions.tips.toggleRequest());
  }, [ dispatch ]);

  return tipsEnabled ? (
    <div
      className={cx(tipsButton, {
        [tipsButtonDesktop]: !DeviceInfo.isHandheld,
      })}
      data-name="tip-button"
      onClick={() => {
        DeviceInfo.isHandheld ? toggleTips() : onTipsClick();
      }}
    >
      {locales.tipTheDealer}
    </div>
  ) : null;
};

const ResultMessageTips = () => {
  const { tipsOnResult } = useGameResults();

  return tipsOnResult ? <ResultMessageTipsInner /> : null;
};

export { ResultMessageTips };
